const getWebCommonApiUrl = (tier) => {
  switch (tier) {
    case "dev":
      return "https://www-dev.telia.ee/common/api";
    case "test":
      return "https://www-test.telia.ee/common/api";
    case "live":
    default:
      return "https://www.telia.ee/common/api";
  }
};
const getSelfServiceBaseUrl = (tier) => {
  switch (tier) {
    case "dev":
      return "https://iseteenindus-dev.telia.ee";
    case "test":
      return "https://iseteenindus-test.telia.ee";
    case "live":
    default:
      return "https://iseteenindus.telia.ee";
  }
};
export {
  getSelfServiceBaseUrl,
  getWebCommonApiUrl
};
